import { markRFIAsClosed } from "@/api/rfi";
import { deleteRFI } from "@/api/rfi";
import { OrangeButtonWithIcon, RouteButton } from "@/components/Buttons";
import { RFIProps } from "@/interfaces/rfi_types";
import { CiEdit } from "react-icons/ci";
import { FaCheck, FaRegEnvelopeOpen } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

export function EditRFIButton({rfi_id}: {rfi_id: string}) {
    return (
        <RouteButton route={`/rfi/update_rfi/${rfi_id}`} text="Edit" icon={<CiEdit />} />
    )
}

// Function that sends an email to the assigned person with the RFI details
// This is used to remind the assigned person to do the RFI
export function HandleEmail({data}: {data: RFIProps}) {
    const handleEmailClick = () => {
        const recipient = data.assigned_to?.email
        const ccRecipient = data.created_by?.email
        const subject = `Regarding RFI ${data.RFI_number ?? 'N/A'} for Project ${data.project_name ?? 'N/A'}`
        const body = `Hello ${data.assigned_to?.name ?? ''},\n\nPlease see the details for RFI ${data.RFI_number ?? 'N/A'}:\n\nDescription:\n${data.description}\n\nThank you,\n${data.created_by?.name ?? ''}`

        if (!recipient) {
            alert("Cannot send email: Assigned person's email is missing.")
            return
        }

        let mailtoUrl = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`

        if (ccRecipient) {
            mailtoUrl += `&cc=${encodeURIComponent(ccRecipient)}`
        }
        
        window.location.href = mailtoUrl
    }

    return (
        <OrangeButtonWithIcon onClick={handleEmailClick} icon={<FaRegEnvelopeOpen />}>Email Assigned User</OrangeButtonWithIcon>
    )
}

export function HandleClose({data}: {data: RFIProps}) {
    const navigate = useNavigate()

    const handleClose = async () => {
        if (confirm("Are you sure you want to close this RFI?")) {
            if (data.RFI_id) {
                try {
                    const response = await markRFIAsClosed(data.RFI_id)
                    if (response.operation === "COMPLETED") {
                        alert("RFI closed successfully")
                        navigate("/rfi")
                    } else {
                        alert("Error closing RFI")
                    }
                } catch (error) {
                    console.error("Error closing RFI:", error)
                }
            }
        }
    }

    return (
        <OrangeButtonWithIcon onClick={handleClose} icon={<FaCheck />}>Close</OrangeButtonWithIcon>
    )
}

export function HandleDelete({data}: {data: RFIProps}) {
    const navigate = useNavigate()

    const handleDelete = async () => {
        if (confirm("Are you sure you want to delete this RFI? In most cases, it would be better to close it out.") && confirm("Are you really sure you want to delete this RFI?")) {
            if (data.RFI_id) {
                const response = await deleteRFI(data)
                if (response.operation === "COMPLETED") {
                    alert("RFI deleted successfully")
                    navigate("/rfi")
                } else {
                    alert("Error deleting RFI")
                }
            }
        }
    }

    return (
        <OrangeButtonWithIcon onClick={handleDelete} icon={<AiOutlineDelete />}>Delete</OrangeButtonWithIcon>
    )
}
